function isNineBySixteen(template: { width: number; height: number }) {
    const { width, height } = template;
    const aspectRatio = width / height;
    const targetRatio = 9 / 16;
    const tolerance = 0.1;

    return Math.abs(aspectRatio - targetRatio) < tolerance;
}

export default isNineBySixteen;
